<template>
	<card-toolbar style="padding-bottom: 30px;">
		<div slot="left" class="buttons has-addons">
			<b-checkbox class="mr-20" v-model="isHiddenContain">非表示も含める</b-checkbox>
			<b-select class="" v-model="customerId">
				<option value="">企業選択</option>
				<option
					v-for="c in customers"
					:value="c.id"
					:key="c.id">
					{{ c.name }}
				</option>
			</b-select>
		</div>

		<div slot="right" class="buttons has-addons">
			<b-button class="search-button" type="is-success" @click="onSearchButtonClick">検索</b-button>
		</div>
	</card-toolbar>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
export default {
	name: "ShopTableToolbar",
	components: {
		CardToolbar
	},
	props: {
		customers: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			isHiddenContain: false,
			customerId: '',
		}
	},
	methods: {
		onSearchButtonClick: function() {
			this.$emit('search-button-click', this.isHiddenContain ? 1 : 0, this.customerId);
		},
	}
}
</script>

<style scoped>

</style>
